/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Decklists_Mode_HintInputs */



/**
* | output |
* | --- |
* | "Which decks are published after the tournament:" |
*
* @param {Og_Cfg_Decklists_Mode_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_decklists_mode_hint = /** @type {((inputs?: Og_Cfg_Decklists_Mode_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Decklists_Mode_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quels decks sont publiés après le tournoi :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Qué mazos se publican después del torneo:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quais decks são publicados após o torneio:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quali mazzi vengono pubblicati al termine del torneo:")
	return /** @type {LocalizedString} */ ("Which decks are published after the tournament:")
});